import classNames from 'classnames';
import { StaticImage } from 'gatsby-plugin-image';

import EnrollmentChecklist from '~components/LeadForm/EnrollmentChecklist/EnrollmentChecklist';
import Grid from '~components/_layout/Grid/Grid';

import * as styles from './NewToMedicareChecklist.module.css';

type Props = {
    backgroundsurface?: SupportedBackgroundColor;
    tcpadisclaimercopy: string;
};

const NewToMedicareChecklist = ({
    backgroundsurface = 'bg-surface-50',
    tcpadisclaimercopy = '',
    children = null,
}: React.PropsWithChildren<Props>) => {
    return (
        <article
            className={classNames(
                styles.newToMedicareChecklistArticle,
                'font-poppins px-4 py-6 md:px-6 md:py-9 lg:py-20',
                backgroundsurface
            )}
            data-qa="new-to-medicare-checklist"
        >
            <Grid>
                <div className="col-span-4 md:col-span-3 lg:col-span-5 flex justify-center px-8 md:px-0 mb-5 md:mb-0">
                    <div>
                        <StaticImage
                            src="./images/n2m-checklist-hero.svg"
                            placeholder="blurred"
                            loading="lazy"
                            width={415}
                            height={530}
                            alt=""
                        />
                    </div>
                </div>
                <div className="col-span-4 md:col-span-5 lg:col-span-7">
                    <div className={styles.newToMedicareChecklistArticleChildren}>{children}</div>
                    <div className="mt-6 lg:mt-12">
                        <EnrollmentChecklist />
                    </div>
                    <p
                        className="font-poppins font-normal text-link-visited text-16 tracking-wide break-words mt-8"
                        dangerouslySetInnerHTML={{ __html: tcpadisclaimercopy }}
                    ></p>
                </div>
            </Grid>
        </article>
    );
};

export default NewToMedicareChecklist;
